module.exports = __webpack_public_path__ + "static/media/improved-quality.ba466323.svg";